import { graphql } from 'react-relay';

export const shopRoot = graphql`
    query shopRootQuery($urlLabel: String!, $previewId: String) {
        viewer {
            landingPage(urlLabel: $urlLabel, previewId: $previewId) {
                title
                seoTitle
                seoDescription
                ...ShopWrapper_landingPage
            }
        }
    }
`;
